import React, {PureComponent} from "react"

import FormattedMessage from "@irati/utils/lang"

import {Button, Wrapper} from "./styled"

interface Props {
  onClickFirstButton: () => void,
  onClickSecondButton: () => void,
  firstButtonText: string,
  secondButtonText: string
}

interface State {
  isFirstButtonActive: boolean
}

class ButtonToggle extends PureComponent<Props, State> {
  state: State = {
    isFirstButtonActive: true
  }

  handleFirstClick = () => {
    this.setState({isFirstButtonActive: true})
    this.props.onClickFirstButton()
  }

  handleSecondClick = () => {
    this.setState({isFirstButtonActive: false})
    this.props.onClickSecondButton()
  }

  render() {
    const {isFirstButtonActive} = this.state
    const {firstButtonText, secondButtonText} = this.props

    return <Wrapper>
      <Button primary={isFirstButtonActive} onClick={this.handleFirstClick}>
        <FormattedMessage id={firstButtonText} />
      </Button>
      <Button primary={!isFirstButtonActive} onClick={this.handleSecondClick}>
        <FormattedMessage id={secondButtonText} />
      </Button>
    </Wrapper>
  }
}

export default ButtonToggle
